/* Aloe Jewels – helper for sections/aj-reviews-heading.liquid.
   Copies numbers that Judge.me already prints in its review widget (average rating, share of 5-star reviews)
   into data attributes, so assets/aj-reviews.css can show them in the AJ layout. Display only. */
(function () {
  var config = document.querySelector('[data-aj-reviews]');
  if (!config) return;

  var scheduled = false;

  function apply() {
    scheduled = false;
    var widget = document.querySelector('.jdgm-rev-widg');
    if (!widget) return;

    var count = parseInt(widget.getAttribute('data-number-of-reviews'), 10) || 0;
    var average = parseFloat(widget.getAttribute('data-average-rating')) || 0;
    var hasReviews = count > 0 && average > 0;

    // Heading + AJ layout only when the product really has reviews
    config.hidden = !hasReviews;
    widget.classList.toggle('aj-reviews', hasReviews);
    if (!hasReviews) return;

    var summary = widget.querySelector('.jdgm-rev-widg__summary-inner');
    if (summary) {
      var score = average.toFixed(1).replace('.', config.getAttribute('data-decimal') || '.');
      if (summary.getAttribute('data-aj-score') !== score) summary.setAttribute('data-aj-score', score);
    }

    var histogram = widget.querySelector('.jdgm-histogram');
    var fiveStars = histogram && histogram.querySelector('.jdgm-histogram__row[data-rating="5"]');
    if (fiveStars) {
      var template = config.getAttribute('data-pill') || '';
      var percent = parseInt(fiveStars.getAttribute('data-percentage'), 10) || 0;
      var minimum = parseInt(config.getAttribute('data-min-share'), 10) || 0;
      if (template && percent >= minimum) {
        var pill = template.replace('[percent]', percent);
        if (histogram.getAttribute('data-aj-pill') !== pill) histogram.setAttribute('data-aj-pill', pill);
      } else if (histogram.hasAttribute('data-aj-pill')) {
        histogram.removeAttribute('data-aj-pill');
      }
    }

    // Title of the "reviews in other languages" part: use the theme's wording for this language when one is set
    var otherTitle = config.getAttribute('data-other-title');
    var otherHeading = otherTitle && widget.querySelector('.jdgm-rev-widg__section-title');
    if (otherHeading && otherHeading.textContent !== otherTitle) otherHeading.textContent = otherTitle;
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(apply);
  }

  // Judge.me fills (and sometimes re-renders) its widget after the page has loaded
  new MutationObserver(schedule).observe(document.getElementById('judgeme_product_reviews') || document.body, {
    childList: true,
    subtree: true
  });
  schedule();
})();
